export { default as ProtectedRoutes } from './ProtectedRoutes';
